/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function PbrTextures(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.6355 1.84458C9.86189 1.71881 10.1376 1.71895 10.364 1.84458L14.8787 4.35239C15.2408 4.55355 15.3718 5.01081 15.1707 5.3729C14.982 5.71207 14.5686 5.84801 14.2195 5.6981L14.1501 5.66392L9.99878 3.35728L4.0437 6.66587L9.99976 9.97446L17.1355 6.0106C17.3676 5.88172 17.6508 5.88597 17.8796 6.02036C18.1086 6.1551 18.2497 6.40117 18.2498 6.66685V9.16685C18.2496 9.43908 18.102 9.68989 17.864 9.82212L10.364 13.9891C10.1376 14.1147 9.86187 14.1148 9.6355 13.9891L3.24976 10.4403V11.2245L9.99976 14.9745L17.1355 11.0106C17.3676 10.8817 17.6508 10.886 17.8796 11.0204C18.1086 11.1551 18.2497 11.4012 18.2498 11.6668V14.1668C18.2496 14.4391 18.102 14.6899 17.864 14.8221L10.364 18.9891C10.1376 19.1147 9.86187 19.1148 9.6355 18.9891L2.1355 14.8221C1.77377 14.6209 1.64351 14.1645 1.84448 13.8026C2.04555 13.4407 2.50201 13.3098 2.86401 13.5106L9.99976 17.4745L16.7498 13.7245V12.9403L10.364 16.4891C10.1376 16.6147 9.86187 16.6148 9.6355 16.4891L2.1355 12.3221C1.89774 12.1898 1.74987 11.9389 1.74976 11.6668V9.16685C1.74981 8.90126 1.89103 8.65513 2.11987 8.52036C2.3487 8.38583 2.63189 8.38187 2.86401 8.5106L9.99976 12.4745L16.7498 8.72446V7.94028L10.364 11.4891C10.1376 11.6147 9.86187 11.6148 9.6355 11.4891L2.1355 7.32212C1.89774 7.18983 1.74987 6.93894 1.74976 6.66685C1.74981 6.39463 1.89759 6.14288 2.1355 6.0106L9.6355 1.84458Z"
        fill="currentColor"
      />
    </svg>
  )
}

PbrTextures.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default PbrTextures
